import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import { reducers } from './reducers';
import App from './App';

// This imports function to keep the server active
// import keepServerActive from './keepServerActive'; 
// This imports function to keep the server active

import './index.css';

const store = createStore(reducers, compose(applyMiddleware(thunk)));

// Calls the function to keep the server active
// keepServerActive();
// Calls the function to keep the server active 

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
